var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "#5F5FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.65H13.33C11.55 13.65 10.1 12.21 10.1 10.42V8.25C10.1 7.84 9.77 7.5 9.35 7.5H6.18C3.87 7.5 2 9 2 11.68V18.32C2 21 3.87 22.5 6.18 22.5H12.07C14.38 22.5 16.25 21 16.25 18.32V14.4C16.25 13.98 15.91 13.65 15.5 13.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8217 2.5H15.8517H14.7617H11.9317C9.67172 2.5 7.84172 3.94 7.76172 6.51C7.82172 6.51 7.87172 6.5 7.93172 6.5H10.7617H11.8517H13.8217C16.1317 6.5 18.0017 8 18.0017 10.68V12.65V15.36V17.33C18.0017 17.39 17.9917 17.44 17.9917 17.49C20.2217 17.42 22.0017 15.94 22.0017 13.33V11.36V8.65V6.68C22.0017 4 20.1317 2.5 17.8217 2.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9806 7.64975C11.6706 7.33975 11.1406 7.54975 11.1406 7.97975V10.5998C11.1406 11.6998 12.0706 12.5998 13.2106 12.5998C13.9206 12.6098 14.9106 12.6098 15.7606 12.6098C16.1906 12.6098 16.4106 12.1098 16.1106 11.8098C15.0206 10.7198 13.0806 8.76975 11.9806 7.64975Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f4a80347715ec6a10eefcbede2282938.svg";
export { ForwardRef as ReactComponent };